export const setProjects=(cltprojectList)=>{
    return {
        type:"FETCH_PROJECT_LIST",
        payload: cltprojectList
    }
}
